module.exports = __webpack_public_path__ + "assets/search.03180b70.svg";